var BaseViews = require('../base');
require('./loader-expanded/loader-expanded.scss');
var LoaderExpanded = BaseViews.LayoutView.extend({
    className: 'fmcy-loader-expanded',
    template: require('./loader-expanded/loader-expanded.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
    },
    regions: {
        contentRegion: '.fmcy-loader-expanded-content-region',
    },
    onRender: function() {
      var self = this;

      if (this.options.theme == 'dark') {
        this.$el.addClass('dark');
      }

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = LoaderExpanded;



/** WEBPACK FOOTER **
 ** ./assets/js/common/loader-expanded/loader-expanded.js
 **/